export enum Roles {
    ADMINISTRATOR = 'pf_administrator',
    MANAGER = 'pf_manager',
    SERVICE_DESK = 'pf_servicedesk',
    REPORTER = 'pf_reporter'
}